<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    class="icon"
  >
    <g :fill="color">
      <slot />
    </g>
  </svg>
</template>

<script>
  export default {
    name: "BaseIcon",
    props: {
      color: {
        type: String,
        default: ""
      },
      width: {
        type: [Number, String],
        default: 24
      },
      height: {
        type: [Number, String],
        default: 24
      }
    }
  };
</script>

<style scoped lang="scss">
  .icon {
  }
</style>
